import initialState from "./initialState";
import {
  GET_HOME_INIT,
  GET_HOME_SUCCESS,
  GET_HOME_FAILURE,
  ACTIVE_COMPANY_INIT,
  ACTIVE_COMPANY_SUCCESS,
  ACTIVE_COMPANY_FAILURE,
  RESET_HOME,
  RESET_ACTIVE_COMPANY,
} from "../../actions/home/types";

export default function home(state = initialState, action) {
  switch (action.type) {
    /* Setting */
    case RESET_HOME:
      return {
        ...state,
        data: {},
        loading: true,
        status: 0,
      };
    case RESET_ACTIVE_COMPANY:
      return {
        ...state,
        dataActiveCompany: {},
        loadingActiveCompany: false,
        statusActiveCompany: 0,
      };
    case GET_HOME_INIT:
      return {
        ...state,
        loading: true,
      };
    case GET_HOME_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        status: action.payload.status,
      };
    case GET_HOME_FAILURE:
      return {
        ...state,
        data: {},
        loading: false,
        status: 501,
      };
    case ACTIVE_COMPANY_INIT:
      return {
        ...state,
        loadingActiveCompany: true,
      };
    case ACTIVE_COMPANY_SUCCESS:
      return {
        ...state,
        dataActiveCompany: action.payload.data,
        loadingActiveCompany: false,
        statusActiveCompany: action.payload.status,
      };
    case ACTIVE_COMPANY_FAILURE:
      return {
        ...state,
        dataActiveCompany: {},
        loadingActiveCompany: false,
        statusActiveCompany: 501,
      };

    default:
      return state;
  }
}
